import React, { useEffect, useState } from 'react'
import CasePaymentInformationView from './components/CasePaymentInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const CasePaymentInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('case-payment-information', 'Make a Restitution Payment', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <CasePaymentInformationView setIsError={setIsError} />
}

export default withTranslation('common')(CasePaymentInformation)
